import axios from 'axios';

export default (type) => axios.create({
  baseURL: process.env[type],
});
